import Axios from "axios";
import { ApiBaseUrl, KycBaseUrl } from "../config/config";
import { ApiResultModel } from "../models/common.model";
import {
  CheckOtpRequest,
  CheckOtpResponse,
  RefreshToken,
  SendOtpRequest,
  SendOtpResponse,
} from "../models/security.model";

export const CheckOtp = (
  data: CheckOtpRequest
): Promise<ApiResultModel<CheckOtpResponse>> => {
  return Axios.post<ApiResultModel<CheckOtpResponse>>(
    ApiBaseUrl + KycBaseUrl + "/CheckOtp",
    data
  ).then((result) => {
    return result.data;
  });
};

export const sendOtp = (data: SendOtpRequest): Promise<SendOtpResponse> => {
  return Axios.post<ApiResultModel<SendOtpResponse>>(
    ApiBaseUrl + KycBaseUrl + "/SendOtp",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetAccessTokenByRefreshToken = (
  data: RefreshToken
): Promise<CheckOtpResponse> => {
  return Axios.post<ApiResultModel<CheckOtpResponse>>(
    ApiBaseUrl + KycBaseUrl + "/GetAccessTokenByRefreshToken",
    data
  ).then((result) => {
    return result.data.data;
  });
};
